import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import API from '@/api/api';

const useEstimateStore = create(
  subscribeWithSelector((set, get) => ({
    EstimateInfo: {},
    EstimateDocuments: [],
    EstimateCycles: [],
    ActiveEstimateSiteInfoId: null,

    // mutation
    setActiveEstimateSiteInfoId: (estimate_site_info_id) => {
      set({ ActiveEstimateSiteInfoId: estimate_site_info_id });
    },

    // Dispatch
    fetchEstimateInfo: async (estimate_info_id) => {
      let EstimateInfo = await API.get(`/estimates/${estimate_info_id}`);
      set({ EstimateInfo: EstimateInfo.data });
    },

    fetchEstimateDocuments: async () => {
      const { EstimateInfo } = get();
      let EstimateDocuments = await API.get(
        `/projects/${EstimateInfo.project.project_id}/document-requirements`
      );
      set({ EstimateDocuments: EstimateDocuments.data });
    },

    fetchEstimateCycles: async () => {
      const { EstimateInfo, ActiveEstimateSiteInfoId } = get();
      let EstimateCycles = await API.get(
        `/estimates/${EstimateInfo.estimate_info_id}/sites/${ActiveEstimateSiteInfoId}`
      );
      set({ EstimateCycles: EstimateCycles.data });
    },
  }))
);

useEstimateStore.subscribe(
  (state) => state.EstimateInfo,
  async (newEstimateInfo) => {
    if (newEstimateInfo?.project?.project_id) {
      await useEstimateStore.getState().fetchEstimateDocuments();
    }
  }
);

useEstimateStore.subscribe(
  (state) => state.ActiveEstimateSiteInfoId,
  async (newActiveEstimateSiteInfoId) => {
    if (newActiveEstimateSiteInfoId !== null) {
      await useEstimateStore.getState().fetchEstimateCycles();
    }
  }
);

export default useEstimateStore;
